import Link from "next/link";
import { FileQuestion, Phone } from "@/components/icons";
import { Button } from "@/components/ui/button";
import { COMPANY } from "@/config/company";

interface AccessoryEmptyCTAProps {
  parentTypeName?: string;
  accessoryTypeName?: string;
}

export function AccessoryEmptyCTA({
  parentTypeName,
  accessoryTypeName,
}: AccessoryEmptyCTAProps) {
  const heading = accessoryTypeName
    ? `Looking for ${accessoryTypeName}?`
    : parentTypeName
      ? `Need ${parentTypeName} accessories?`
      : "Need industrial packaging accessories?";

  const productParam = parentTypeName
    ? `&product=${encodeURIComponent(parentTypeName.toLowerCase())}`
    : "";

  return (
    <div className="rounded-lg border border-dashed border-primary/30 bg-brand-tint px-6 py-10 text-center">
      <FileQuestion className="mx-auto h-10 w-10 text-brand-strong/60 mb-4" />
      <h3 className="text-lg font-semibold text-foreground mb-2">{heading}</h3>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
        <Button variant="primary" asChild>
          <Link href={`/request-quote?type=buy${productParam}`}>
            Check availability
          </Link>
        </Button>
        <Button variant="outline" asChild>
          <Link href={`tel:${COMPANY.PHONE_TEL}`}>
            <Phone className="h-4 w-4 mr-2" />
            {COMPANY.PHONE_FORMATTED}
          </Link>
        </Button>
      </div>
    </div>
  );
}
